export function addTalkDeskStarterScript(customerId, customerName, customerNumber, email, flowId) {
  const src = "https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js";
  const script = document.createElement("script");
  const firstScriptTag = document.getElementsByTagName("script")[0];
  const isMobile = window.innerWidth < 1200;

  script.type = "text/javascript";
  script.charset = "UTF-8";
  script.id = "tdwebchatscript";
  script.src = src;
  script.async = true;
  script.defer = "defer";

  firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  script.onload = () => {
    // Create the webchat instance and initialize it with provided configurations.
    const webchat = window.TalkdeskChatSDK("tdWebchat", {
      flowId: flowId,
      accountId: "",
      region: "td-eu-1",
    });
    webchat.setContextParam({
      customer_id: customerId,
      contact_name: customerName,
      contact_number: customerNumber,
      contact_email: email,
      td_contact_person_identification: email,
    });
    webchat.init({
      enableEmoji: true,
      enableUserInput: true,
      styles: {
        chatThemeColor: '#0057b7',
        chatTitle: 'WPA Chat',
        chatSubtitle: '',
        welcomeMessageBackgroundColor: '#0b2d7b',
        customButtonColor: '#0057b7',
        customButtonBorderColor: '#0057b7',
        userBackgroundColor: '#0b2d7b',
        userAnchorTextColor: '#0b2d7b',
        userAnchorTextColorVisited: '#95C6E5',
        botAnchorTextColor: '#0b2d7b',
        botAnchorTextColorVisited: '#95C6E5',
        chatConfirmButtonBackgroundColor: '#0057b7',
        chatCancelButtonFontColor: '#0057b7',
        startChatButtonBackgroundColor: '#0057b7',
        startChatButtonBorderColor: '#0057b7',
        startChatButtonHoverBackgroundColor: '#0057b7',
        startChatButtonHoverBorderColor: '#0057b7',
        buttonTextColor: '#0057b7',
        buttonHoverBackgroundColor: '#0b2d7b',
        replyTextColor: '#0057b7',
        replyBorderColor: '#0057b7',
        replyHoverTextColor: '#95C6E5',
        ...(isMobile && {triggerButtonPositionBottom: '4.5rem'}),
      },
      enableAttachments: true
    });
  };
}
